import React from 'react';
import Icon from 'components/Icon';
import styles from './index.module.scss';
import { useStore, StoreTypes } from 'context';
import { gaOnebookEvent } from 'components/AppService/GAService';
import { getModuleFromPath } from 'constants/gaEventType';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const [{ isLogin, userId, role }] = useStore(StoreTypes.user);
  const { pathname } = useLocation();
  const menus = [
    {
      title: '歡迎光臨',
      items: [
        {
          text: 'onemall 閱讀器',
          link: ''
        },
        {
          text: '全站活動',
          link: ''
        },
        {
          text: '下載APP',
          link: ''
        },
        {
          text: '常見問題 Q&A',
          link: ''
        },
        {
          text: '我要買書',
          link: ''
        },
        {
          text: '意見回報',
          link: ''
        }
      ]
    },
    {
      title: '關於我們',
      items: [
        {
          text: '公司資訊',
          link: ''
        },
        {
          text: '徵人啟事',
          link: ''
        },
        {
          text: '合作提案',
          link: ''
        },
        {
          text: 'AP推書夥伴',
          link: ''
        }
      ]
    },
    {
      title: '服務條款',
      items: [
        {
          text: '服務條款',
          link: ''
        },
        {
          text: '隱私權條款',
          link: ''
        }
      ]
    },
    {
      title: '社群連結',
      items: [
        {
          text: 'Fackbook',
          link: ''
        },
        {
          text: 'Line',
          link: ''
        }
      ]
    }
  ];

  const dialogCopyright = () => {
    alert('版權聲明：茲就南一書局企業股份有限公司（以下簡稱本公司）所提供之著作（包括但不限於文字、攝影、圖形、錄音、視聽暨其以Word或PDF等數位形式出版產品，及未來以各種形式發表之產品或內容），其著作財產權均歸屬於本公司所有或經具有合法權源之人授權使用，並受著作權法保護。各級學校及其擔任教學之人，基於為學校授課目的之必要範圍內，得在不逾越著作權法第46條、第46之1條及第65條規定下，合理使用本公司已公開發表之著作，但於利用時亦應以合理方式明示其出處。')
  }

  return (
    <footer>
      <div className={styles.container}>
        {/* <div className={styles.top}>
                    {
                        menus.map((list, index) => {
                            return (
                                <div key={index} className={styles.list_box}>
                                    <h2>{list.title}</h2>
                                    <ul className={styles.list_sub_box}>
                                        {list.items.map((list, i) => <li key={i} className={styles.list}>{list.text}</li>)}
                                    </ul>
                                </div>
                            );
                        })
                    }
                </div> */}
        <div className={styles.connectionInfo}>
          <div>
            <div>
              <h2 className={styles.connectionUs}>聯繫我們</h2>
              <hr className={styles.connectionInfoHR} />
            </div>
          </div>
          <div className={styles.connectionInfoButtons}>
            <div></div>
            <div>
              <a href="https://s.nani.cool/ebookforms" target='_blank' rel='noopener noreferrer'>
                <div className="mb-3 text-muted">
                  <Icon type="text" name="envelope" />
                </div>
                <div>意見回饋</div>
              </a>
            </div>
            <div>
              <a href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe" download onClick={() => {
                gaOnebookEvent({
                  module: getModuleFromPath(pathname),
                  tapEvent: '遠端連線',
                  accountId: isLogin ? userId : '',
                  role,
                });
              }}>
                <div className="mb-3 text-muted">
                  <Icon type="text" name="tools" />
                </div>
                <div>遠端連線</div>
              </a>
            </div>
            <div></div>
          </div>
          <div className={styles.command}>
            為了讓您獲得最佳瀏覽體驗，建議您使用的瀏覽器軟體為：IE Edge、Google
            Chrome 或 Firefox。
            <br />{' '}
            如使用IE瀏覽器瀏覽本網站，可能會發生部分網頁的呈現會有破圖或版面跑版的情況，亦可能導致某些網頁互動功能無法正確顯示與使用。
          </div>
        </div>
        <div className={styles.bottom}>
          <div>南一教育股份有限公司 Copyright ©</div>
          <div className={styles.copyrightBtn} onClick={() => dialogCopyright()}>版權聲明</div>
          <div className={styles.copyrightBtn} onClick={() => {
            gaOnebookEvent({
              module: getModuleFromPath(pathname),
              tapEvent: '數位條款',
              accountId: isLogin ? userId : '',
              role,
            });
            window.open('https://docs.nani.com.tw/pricing-licensing/index.html', '_blank');
          }}>數位教學服務授權金額與服務條款</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
